import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgEditIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="edit_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M45 9.586 22.293 32.293a1 1 0 0 0-.258.444l-3 11A1 1 0 0 0 20 45a1.028 1.028 0 0 0 .263-.035l11-3a1 1 0 0 0 .444-.258L54.414 19ZM60.414 10.172l-6.586-6.586a2 2 0 0 0-2.828 0l-4.586 4.586 9.414 9.414L60.414 13a2 2 0 0 0 0-2.828Z"
      />
      <path d="M50 61H6a3 3 0 0 1-3-3V14a3 3 0 0 1 3-3h20a1 1 0 0 1 0 2H6a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h44a1 1 0 0 0 1-1V38a1 1 0 0 1 2 0v20a3 3 0 0 1-3 3Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgEditStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgEditIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const EditIcon: any = SvgEditStyle;
export default EditIcon;
